import CheckIcon from '@mui/icons-material/Check'
import { Badge, Box } from '@mui/material'
import { TemplateIconTypeEnum } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { updateTemplateIcons } from 'src/state/ducks/templates/editTemplate/actions'
import type { RootState } from 'src/state/store'

const PopoverIcon: FC<{
  templateIcon: {
    backgroundColor: string
    value: TemplateIconTypeEnum
    svgComponent: React.FunctionComponent<
      React.SVGProps<SVGSVGElement> & {
        title?: string | undefined
      }
    >
    label: string
  }
}> = ({
  templateIcon: { value, backgroundColor, svgComponent: SVG, label },
}) => {
  const dispatch = useDispatch()
  const templateIcons = useSelector(
    (state: RootState) => state.templatesState.editTemplate.icons,
    shallowEqual,
  )

  const onClick = () => {
    const selectedTemplateIcon = templateIcons.find(
      ({ iconType }) => iconType === value,
    )

    if (selectedTemplateIcon !== undefined) {
      // 未調査: こっちの分岐が実行されることはないのでは？
      dispatch(
        updateTemplateIcons(
          templateIcons.filter(({ iconType }) => iconType !== value),
        ),
      )
    } else {
      dispatch(
        updateTemplateIcons([
          ...templateIcons,
          {
            iconType: value,
          },
        ]),
      )
    }
  }

  const isSelected = templateIcons.find(({ iconType }) => iconType === value)

  return (
    <Badge
      overlap="circular"
      color="primary"
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      invisible={!isSelected}
      badgeContent={
        <CheckIcon
          sx={{ width: 16, height: 16, color: 'primary.contrastText' }}
        />
      }
      role="button"
      tabIndex={0}
      aria-label={label}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault()
          onClick()
        }
      }}
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        '& .MuiBadge-badge': {
          p: 0.25,
          minWidth: 'unset',
          height: 'unset',
        },
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          bgcolor: backgroundColor,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <SVG
          width={24}
          height={24}
          fill="#ffffff"
          role="img"
          aria-label={label}
        />
      </Box>
    </Badge>
  )
}

export default PopoverIcon
